import Ordering from './containers/Ordering';

export default Ordering;
